/** @type {import('../help-index.js').HelpSidebarItem} */
export const TAX_OBL_LIABILITIES_ITEM = {
  id: 'obligations_sidebar',
  screenId: 'tax-obl-liabilities',
  label: 'Obligaciones',
  description: 'Saldos a pagar de impuestos (IVA, IIBB, sellos, etc.).',
  detail: {
    sections: [
      {
        title: 'Para qué sirve',
        intro:
          'Registrás y seguís lo que debés pagar de cada impuesto por período: monto, vencimiento, pagos parciales y estado. Incluye obligaciones generadas desde Liquidación IVA.',
      },
      {
        title: 'Paso 1 — Filtrar la lista',
        fields: [
          { label: 'Impuesto', description: 'Todos o un impuesto del catálogo.' },
          { label: 'Estado', description: 'Borrador, Confirmada, Parcialmente pagada, Pagada, Cancelada o En plan de pago.' },
        ],
        bullets: [
          'Columnas: Impuesto, Período, Jurisdicción, Venc., Monto, Pagado, Pendiente, Estado.',
          'Tocá una fila para ver detalle, registrar pagos o cancelar.',
        ],
      },
      {
        title: 'Paso 2 — Registrar saldo a pagar',
        intro: 'Botón +. Campos típicos:',
        fields: [
          { label: 'Impuesto', description: 'Obligatorio.' },
          { label: 'Período', description: 'Mes/año o año según el impuesto.' },
          { label: 'Jurisdicción', description: 'Provincia o ámbito si aplica (IIBB, sellos).' },
          { label: 'Vencimiento / Monto / Moneda', description: 'Importe adeudado y fecha límite.' },
          { label: 'Observaciones', description: 'Notas internas visibles en el detalle.' },
        ],
      },
      {
        title: 'Paso 3 — Detalle y pagos',
        bullets: [
          'Confirmá la obligación para que quede pendiente de pago.',
          'Si la obligación está en un plan de pago, el pago se hace desde Planes de Pago (cuota por cuota), no acá.',
          'Estados: Borrador → Confirmada → Parcialmente pagada → Pagada.',
        ],
      },
    ],
  },
}
